import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../services/common.service';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-announcement-page',
  templateUrl: './announcement-page.component.html',
  styleUrls: ['./announcement-page.component.scss']
})
export class AnnouncementPageComponent implements OnInit {
  isLoading: any;
  announcements: any[] = [];
  displayAnnouncements: any[] = [];
  searchAnnouncementValue: any;
  constructor(private commonService: CommonService,
              public toastMessagesService: ToastMessagesService) { }

  async ngOnInit() {
    await this.initializeForms();
    this.isLoading = false;
  }
  async initializeForms() {
    this.isLoading = true;
    try {
      const formsRequest = await this.commonService.getList('forms/forms/announcements');

      this.announcements = formsRequest.object;
      this.displayAnnouncements = formsRequest.object;
      console.log(this.displayAnnouncements);
    } catch (e) {
      console.log(e.message);
    } finally {
      this.isLoading = false;
    }
  }

  searchForms(tabIndex: number, $event?: any) {
    let filterValue = '';
    switch (tabIndex) {
      case 2:
        filterValue =  this.searchAnnouncementValue ? this.searchAnnouncementValue.trim().toLowerCase() : '';
        this.displayAnnouncements = filterValue ?
            this.announcements.filter(form => form.title.trim().toLowerCase().includes(filterValue)) :
            this.announcements;
        break;
    }
  }

  search() {
  }

  deleteFormEmittedFromChild(id: number) {
    const formIndex = this.announcements.findIndex(f => f.id === +id);
    if (formIndex !== -1) {
      this.announcements.splice(formIndex, 1);
      this.toastMessagesService.toastMessages('Η ανακοίνωση διαγράφηκε με επιτυχία');
    }
  }
}
